<div class="form-group ">
  <div class="input-group">
    <input
      type="text"
      class="form-control"
      [placeholder]="placeholder"
      [(ngModel)]="searchTerm"
      (input)="onSearch($event)"
      (keyup)="onKeyUp($event)" />
    <button class="btn btn-primary" (click)="search()">
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
  </div>
</div> 